import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * Auth token interceptor
 * Ensures credentials (httpOnly cookies) are sent with requests
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // HttpOnly cookies are automatically sent with requests when withCredentials is true
    // Add withCredentials to all non-assets requests
    const assetsI18nReq = request.url.indexOf('assets/i18n') >= 0;

    if (assetsI18nReq) {
      return next.handle(request);
    }

    const requestWithCredentials = request.clone({
      withCredentials: true,
    });

    return next.handle(requestWithCredentials);
  }
}
